<template>
  <div>
      <div class="content-nav-wrapper">
          <div class="title-wrapper">
              <span class="title">{{ $t('comb.todo') }}</span>
              <span>{{ $t('word.total') }} {{ totalCount }} {{ $t('word.item') }}</span>
          </div>
          <div class="tabs-wrapper">
              <button :class="{'active': statusCode===0}" @click="getTodoList(0, 1)"><span>{{ $t('word.all') }}</span><i v-if="$parent.todos['0'] > 0" class="red-dot"></i></button>
              <button :class="{'active': statusCode===1}" @click="getTodoList(1, 1)"><span>{{ $t('comb.invitationProcess') }}</span><i v-if="$parent.todos['1'] > 0" class="red-dot"></i></button>
              <button :class="{'active': statusCode===2}" @click="getTodoList(2, 1)"><span>{{ $t('comb.auditFailure') }}</span><i v-if="$parent.todos['2'] > 0" class="red-dot"></i></button>
              <button :class="{'active': statusCode===3}" @click="getTodoList(3, 1)"><span>{{ $t('comb.taskUpdate') }}</span><i v-if="$parent.todos['3'] > 0" class="red-dot"></i></button>
          </div>
      </div>
      <div class="copyright-empty-task-list" v-if="totalCount === 0 && statusCode===0" >
          <p class="no-task">您可以通过<a :href="`${$store.state.A_PC_HOST}/requirementview`">参加海选</a>或<router-link :to="{name: 'anchorMyVoiceTag'}">添加声音标签</router-link>获得更多播讲机会</p>
      </div>
      <div class="copyright-tasks-list-wrapper" v-else v-loading.body="pageLoading">
          <div v-for="(item,index) in todoList" class="task-item">
              <div class="title">
                  <span v-if="statusCode===1" class="status">{{ item.recruitmentOption===1? '指定任务邀约':item.recruitmentOption===2? '海选任务邀约':'限时任务邀约' }}</span>
                  <span v-else class="status">{{ item.requirementViewStatusLabel }}</span>
                  <span>{{ formatDate(item.requirementCreateTime) }}</span>
              </div>
              <div class="task-content-wrapper">
                  <img v-if="item.requirementLogoPic" class="task-cover" :src="$store.state.UPLOAD_IMG_HOST+item.requirementLogoPic" @error="setDefaultBookCoverImg(index)" ref="img">
                  <img v-else class="task-cover" :src="$store.state.IMG_HOST+'bookCoverDefault.png'">
                  <div :class="{'task-content-single': item.requirementId}" class="task-content">
                      <div class="content">
                          <span class="task-name">{{ item.requirementTitle }}</span>
                          <div v-if="item.typeId === 1 && (item.recruitmentOption===1||item.recruitmentOption===2)"><span class="task-anchor">恭喜，收到任务邀约！请尽快处理。剩余时间：<strong style="color: #fc5832;">{{ item.context }}</strong></span></div>
                          <div v-if="item.typeId === 1 && item.recruitmentOption===4"><span class="task-anchor">恭喜，收到任务邀约！请尽快处理，否则任务可能被其他主播抢走哦！剩余时间：<strong style="color: #fc5832;">{{ item.context }}</strong></span></div>
                          <div v-if="item.typeId === 2"><span class="task-anchor">有<strong style="color: #fc5832;">{{ item.context }}</strong>条声音审核不合格</span></div>
                          <div v-if="item.typeId === 3"><span class="task-anchor">有<strong style="color: #fc5832;">{{ item.context }}</strong>条任务更新</span></div>
                      </div>
                      <div class="buttons">
                          <a v-if="item.typeId === 1" :href="`${$store.state.A_PC_HOST}/requirement/${item.requirementId}/candidate`" class="check-task" target="_blank">{{ $t('comb.toHandle') }}</a>
                          <a v-if="item.typeId === 2" :href="`${$store.state.A_PC_HOST}/workbench/task/${item.taskId}/work`" class="check-task" target="_blank">{{ $t('comb.toHandle') }}</a>
                          <a v-if="item.typeId === 3" :href="`${$store.state.A_PC_HOST}/workbench/task/${item.taskId}/material`" class="check-task" target="_blank">{{ $t('word.check') }}</a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="center-tasks-pagination" v-if="totalPage>=2">
          <el-pagination @current-change="pageChange" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
      </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  export default {
    components: {
      axios,
    },
    data() {
      return {
        pageLoading: true,
        statusCode: 0,
        todoList:[],
        pageIndex: 0,
        totalPage: 0,
        totalCount: 0
      }
    },
    methods: {
      getTodoList(statusCode, pageIndex) {
        this.statusCode = statusCode;
        this.pageLoading = true;
        const that = this;
        this.pageIndex = pageIndex;
        that.taskList = null;
        axios.get(`/api/todo/anchor/type/${statusCode}/pagenum/${this.pageIndex}`,{
        }).then(res => {
          if (res.data.code === 200) {
            that.todoList = res.data.data.items;
            that.totalPage = res.data.data.pages;
            that.totalCount = res.data.data.total;
          }
          that.pageLoading = false;
        });
      },
      setDefaultBookCoverImg(index) {
        this.$refs.img[index].src = this.$store.state.DEFAULT_BOOK_COVER;
      },
      formatDate(data) {
        return moment(data).format('YYYY-MM-DD');
      },
      pageChange(curPage) {
        this.getTodoList(this.statusCode, curPage);
      }
    },
    computed: {
      IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    },
    beforeMount() {
      this.getTodoList(0, 1);
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../../sass/anchor/task-list.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// Todo.vue?6c1457b4